import Model from "./Model";
import { Company, Product, Media } from ".";

export default class CampaignLaunch extends Model {
  static type = "campaignLaunches";

  date!: string;
  company!: Company;
  product!: Product;

  broadcastersCount!: number;
  seconds!: number;
  spotsCount!: number;

  media!: Media;
}
